var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06934 10.8192H9.76378",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2778 15.0047H7.38892L9.73753 16.567C10.0859 16.7992 10.5556 16.5511 10.5556 16.1289V15.0047C12.1389 15.0047 13.1945 13.9492 13.1945 12.3659V9.19919C13.1945 7.61586 12.1389 6.5603 10.5556 6.5603H5.2778C3.69447 6.5603 2.63892 7.61586 2.63892 9.19919V12.3659C2.63892 13.9492 3.69447 15.0047 5.2778 15.0047Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7361 20.3194C20.983 20.3194 22.8044 18.498 22.8044 16.2511C22.8044 14.0043 20.983 12.1829 18.7361 12.1829C16.4893 12.1829 14.6678 14.0043 14.6678 16.2511C14.6678 18.498 16.4893 20.3194 18.7361 20.3194Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7254 28.4559C25.7254 25.3071 22.5929 22.7603 18.7361 22.7603C14.8794 22.7603 11.7468 25.3071 11.7468 28.4559",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8472 27.5763C21.3573 27.5763 21.7708 27.1628 21.7708 26.6527C21.7708 26.1426 21.3573 25.7291 20.8472 25.7291C20.3371 25.7291 19.9236 26.1426 19.9236 26.6527C19.9236 27.1628 20.3371 27.5763 20.8472 27.5763Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9652 25.3331V23.222",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7152 25.8609V23.222",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9445 28.236C17.9445 28.0894 18.4648 28.209 18.4504 28.0677C18.2923 26.5219 17.2981 25.3332 16.0973 25.3332C14.8965 25.3332 13.9023 26.5219 13.7442 28.0677C13.7297 28.209 14.2501 28.0894 14.2501 28.236",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88943 5.01391C9.8086 3.68389 11.449 3.16669 14.0992 3.16669H23.373C28.0099 3.16669 29.5555 4.75002 29.5555 9.50002V28.5C29.5555 33.25 28.0099 34.8334 23.373 34.8334H14.0992C9.46228 34.8334 7.91663 33.25 7.91663 28.5V17.4167",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3402 5.9375H21.7708",
    stroke: "white",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7571 5.9375H16.4932",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.f391fd8958bc1621bd10b9a44976b2cf.svg";
export { ForwardRef as ReactComponent };